import C from './Constants';
import moment from "moment/moment";
import Cookies from "cookies-js"
import $ from "jquery"
import {createMuiTheme} from "@material-ui/core/styles";
import {pink, green, grey, lightGreen, lightBlue, blue, blueGrey, lime, deepPurple, orange, red, deepOrange, yellow, purple, amber, teal, indigo, brown, cyan} from "@material-ui/core/colors";

export class Utils {

    static urlParam(name){
        let results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null){
            return null;
        }
        else{
            return decodeURIComponent(decodeURI(results[1]) || 0).replace(/\+/g," ");
        }
    };

    static guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return "a" + s4() + s4() + s4();
    }

    static readAppParameters (app){
        const groupName = $.urlParam('g');
        if (groupName == null || groupName === ""){
            app.changeGroupName("");
            //app.serverCommunication.serverQueryGroupData();
            //app.serverCommunication.serverQueryAllGroupNames();
            //app.serverCommunication.serverQueryLoginStatus();
        } else {
            app.changeGroupName(groupName);
        }
        const selectedDate = $.urlParam('d');
        if (selectedDate != null && selectedDate.match(C.inputDatePatternRegex)) {
            app.changeSelectedDate(moment(selectedDate, C.inputDatePatternMoment));
        }
    }

    static colorStringToObject(colorString, defaultColor){
        switch (colorString) {
            case "cyan": return cyan;
            case "lime": return lime;
            case "brown": return brown;
            case "amber": return amber;
            case "purple": return purple;
            case "yellow": return yellow;
            case "pink": return pink;
            case "indigo": return indigo;
            case "lightBlue": return lightBlue;
            case "lightGreen": return lightGreen;
            case "blueGrey": return blueGrey;
            case "deepOrange": return deepOrange;
            case "deepPurple": return deepPurple;
            case "grey": return grey;
            case "green": return green;
            case "blue":return blue
            case "orange":return orange;
            case "red":return red;
            case "teal":return teal;
            default:
                return defaultColor;
        }
    }

    static createTheme(primaryColorString, secondaryColorString){
        const primary = this.colorStringToObject(primaryColorString, teal);
        const secondary = this.colorStringToObject(secondaryColorString, orange);

        return createMuiTheme({
            palette: {
                type: 'light',
                primary: primary,
                secondary: secondary,
                error: red,
            }
        })
    }

    static setPrintHourColor(hourTypeIndex, color) {
        Cookies.set('hourType' + hourTypeIndex, color, {secure: true });
    }
    static getPrintHourColor(hourTypeIndex) {
        return Cookies.get('hourType' + hourTypeIndex);
    }

    static setHourPanelViewActive(isActive){
        Cookies.set('userLoggedIn', isActive ? "true" : "false", {expires: 900,  secure: true });//15 minutes, then log out
        return true;
    }

    static setDSGVOAccepted(isAccepted){
        Cookies.set('DSGVOaccepted', isAccepted ? "true" : "false", { secure: true });
    }
    static isDSGVOAccepted(){
        return Cookies.get('DSGVOaccepted') == "true";
    }

    static getHourPanelViewActive(){
        const panelIsActive = Cookies.get('userLoggedIn') == "true";
        return panelIsActive;
    }

    static numberToHex (rgb) {
        let hex = Number(rgb).toString(16);
        if (hex.length < 2) {
            hex = "0" + hex;
        }
        return hex;
    };

    static rgbToHex(r,g,b) {
        let red = Utils.numberToHex(r);
        let green = Utils.numberToHex(g);
        let blue = Utils.numberToHex(b);
        return "#"+red+green+blue;
    };

    static rgb_to_RGB(rgb) {
        let sanatizesString = rgb.substring(4, rgb.length - 1);
        console.log(sanatizesString);
        let splitString = sanatizesString.split(",");
        return {
            r: parseInt(splitString[0].trim(), 10),
            g: parseInt(splitString[1].trim(), 10),
            b: parseInt(splitString[2].trim(), 10)
        };
    }

    static hex_to_RGB(hex) {
        let m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
        if (m != null) {
            return {
                r: parseInt(m[1], 16),
                g: parseInt(m[2], 16),
                b: parseInt(m[3], 16)
            };
        }
        let m2 = hex.match(/^#?([\da-f]{1})([\da-f]{1})([\da-f]{1})$/i);
        return {
            r: parseInt("" + m2[1] + m2[1], 16),
            g: parseInt("" + m2[2] + m2[2], 16),
            b: parseInt("" + m2[3] + m2[3], 16)
        };
    }

    static enterPressed(callbackFunction) {
        return (event) => {
            if (event.keyCode == 13) {
                if(callbackFunction != null)
                    callbackFunction();
            }
        }
    }

    static getResource(resource) {
        // noinspection JSUnresolvedVariable
        return "./resources/" + resource;
    }

    static pollLoginStatus = (serverCommunication, app) => () =>{
        //if(app.isLoggedIn()) serverCommunication.serverQueryLoginStatus();
        //setTimeout(Utils.pollLoginStatus(serverCommunication, app), 300000); //all 300 seconds = 5 minutes
    };

    static isTouchDevice () {
        return 'ontouchstart' in document.documentElement;
    }

    ///https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
    static updateUrlParameter(key, value) {
        let uri = window.location.href;
        // remove the hash part before operating on the uri
        let i = uri.indexOf('#');
        let hash = i === -1 ? ''  : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);

        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = uri.indexOf('?') !== -1 ? "&" : "?";

        if (!value) {
            // remove key-value pair if value is empty
            uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
            if (uri.slice(-1) === '?') {
                uri = uri.slice(0, -1);
            }
            // replace first occurrence of & by ? if no ? is present
            if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
        } else if (uri.match(re)) {
            uri = uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            uri = uri + separator + key + "=" + value;
        }
        return uri + hash;
    }

    static sanitizeString(str){
        str = str.replace(/[^a-z0-9áéíóúñüöäÖÄÜA-Z !?\.,_-]/gim,"");
        return str.trim();
    }
}



export default Utils